var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGettingStarted(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3211_6135)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "themed-icon",
    d: "M5.84485 14.384C5.64171 13.4974 5.53955 12.5907 5.54033 11.6811C5.54033 6.98596 8.21919 2.97368 11.9998 1.3625C15.7805 2.97368 18.4594 6.98596 18.4594 11.6811C18.4594 12.6131 18.3542 13.5184 18.1548 14.384L20.0189 16.0413C20.0991 16.1126 20.1519 16.2097 20.1683 16.3158C20.1846 16.422 20.1634 16.5305 20.1084 16.6226L17.8402 20.4024C17.8041 20.4624 17.7548 20.5135 17.696 20.5516C17.6372 20.5898 17.5705 20.6141 17.501 20.6226C17.4314 20.6311 17.3608 20.6237 17.2946 20.6009C17.2283 20.5781 17.1681 20.5405 17.1185 20.491L15.0386 18.411C14.8656 18.2379 14.6309 18.1407 14.3862 18.1406H9.61352C9.3688 18.1407 9.13412 18.2379 8.96111 18.411L6.88115 20.491C6.83158 20.5405 6.77139 20.5781 6.70513 20.6009C6.63887 20.6237 6.56829 20.6311 6.49874 20.6226C6.42919 20.6141 6.36249 20.5898 6.30372 20.5516C6.24494 20.5135 6.19563 20.4624 6.15953 20.4024L3.89131 16.6236C3.83602 16.5313 3.8147 16.4226 3.83104 16.3163C3.84739 16.2099 3.90037 16.1127 3.98082 16.0413L5.84485 14.384ZM11.9998 11.6811C12.4893 11.6811 12.9588 11.4867 13.3049 11.1405C13.651 10.7944 13.8454 10.325 13.8454 9.83553C13.8454 9.34605 13.651 8.87663 13.3049 8.53051C12.9588 8.1844 12.4893 7.98996 11.9998 7.98996C11.5104 7.98996 11.0409 8.1844 10.6948 8.53051C10.3487 8.87663 10.1543 9.34605 10.1543 9.83553C10.1543 10.325 10.3487 10.7944 10.6948 11.1405C11.0409 11.4867 11.5104 11.6811 11.9998 11.6811Z",
    fill: "#6492F3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "themed-icon",
    d: "M14.8992 19.2809H12.1308H9.36245C9.72752 20.7255 10.6707 22.026 12.1308 22.6365C13.591 22.026 14.5532 20.6744 14.8992 19.2809Z",
    fill: "#6492F3"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3211_6135"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGettingStarted);
export default __webpack_public_path__ + "static/media/getting_started.406f68749596e497ff78c7f9f7ae5984.svg";
export { ForwardRef as ReactComponent };